import { useEffect, useState } from 'react';
import api from '../utils/api';

/**
 * Dati dell'agenzia per le pagine legali pubbliche (Privacy, Cookie, Termini),
 * letti da /api/public/company. I campi mancanti hanno un valore neutro di ripiego.
 */
export interface CompanyInfo {
    agencyName: string;
    address?: string;
    city?: string;
    phone?: string;
    email: string;
    vatNumber?: string;
    website?: string;
    /** true finché la fetch non ha risposto. */
    loading: boolean;
    /** Indirizzo compatto "Indirizzo, Città" con le sole parti presenti. */
    fullAddress?: string;
}

const FALLBACK_NAME = 'La nostra agenzia';
const FALLBACK_EMAIL = '';

export function usePublicCompany(): CompanyInfo {
    const [data, setData] = useState<Record<string, string>>({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let alive = true;
        api.get('/public/company', { skipGlobalErrorToast: true })
            .then((res) => {
                if (!alive) return;
                setData(res?.data?.data || {});
            })
            .catch(() => { /* pagina pubblica: in errore restiamo sui fallback */ })
            .finally(() => { if (alive) setLoading(false); });
        return () => { alive = false; };
    }, []);

    const fullAddress = [data.address, data.city].filter(Boolean).join(', ') || undefined;

    return {
        agencyName: data.agencyName || FALLBACK_NAME,
        address: data.address,
        city: data.city,
        phone: data.phone,
        email: data.email || FALLBACK_EMAIL,
        vatNumber: data.vatNumber,
        website: data.website,
        fullAddress,
        loading,
    };
}

export default usePublicCompany;
